import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  startDate: null,
  endDate: null,
  selectedPeriod: "ytd",
  ratioType: "operating",
};

export const expenseRatioFilterSlice = createSlice({
  name: "expenseRatioFilter",
  initialState,
  reducers: {
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setSelectedPeriod: (state, action) => {
      state.selectedPeriod = action.payload;
    },
    setRatioType: (state, action) => {
      state.ratioType = action.payload;
    },
    resetExpenseRatioFilters: (state) => {
      state.startDate = initialState.startDate;
      state.endDate = initialState.endDate;
      state.selectedPeriod = initialState.selectedPeriod;
      state.ratioType = initialState.ratioType;
    },
  },
});

export const {
  setStartDate,
  setEndDate,
  setSelectedPeriod,
  setRatioType,
  resetExpenseRatioFilters,
} = expenseRatioFilterSlice.actions;

export default expenseRatioFilterSlice.reducer;
